const Galeri = resolve => {
    require.ensure(['../views/apps/galeri/Galeri'], () => {
        resolve(require('../views/apps/galeri/Galeri'))
    })
};
const GaleriDetay = resolve => {
    require.ensure(['../views/apps/galeri/GaleriDetay'], () => {
        resolve(require('../views/apps/galeri/GaleriDetay'))
    })
};

const GaleriTanimla = resolve => {
    require.ensure(['../views/apps/galeri/GaleriTanimla'], () => {
        resolve(require('../views/apps/galeri/GaleriTanimla'))
    })
};
const GaleriListe = resolve => {
    require.ensure(['../views/apps/galeri/GaleriListe'], () => {
        resolve(require('../views/apps/galeri/GaleriListe'))
    })
};
const KategoriTanimlama = resolve => {
    require.ensure(['../views/apps/galeri/kategori/KategoriTanimlama'], () => {
        resolve(require('../views/apps/galeri/kategori/KategoriTanimlama'))
    })
};

import Vue from 'vue'
Vue.component('GaleriDetay', GaleriDetay);
Vue.component('GaleriTanimla', GaleriTanimla);
Vue.component('GaleriListe', GaleriListe);
Vue.component('GaleriKategorileri', KategoriTanimlama);
import layouts from '../layout'

export default {
    path: '/galeri',
    name: 'galeri',
    component: Galeri,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'galeridetay',
            component: GaleriDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
